<template>
  <div class="login-container">
    <!-- Logo Above the Form -->
    <div class="maxxifiedLogoContainer" style="margin-top: 0px !important">
      <img :src="tenant?.getLogo ? tenant?.getLogo : maxxifiedLogo" class="newLogo" alt="" />
    </div>
    <p class="loginTitleNew" style="margin-bottom: 0px !important; margin-top: 30px !important">Create new Account</p>
    <p class="loginSuitTitleNew" style="margin-bottom: 10px !important">Register a new account to get started</p>

    <div class="login-card2">
      <form @submit.prevent="handleSubmit" class="login-card-inner-section">
        <div style="margin-top: 05px">
          <!-- {{ email }} -->
          <custom-input :value="firstName" @update:value="firstName = $event" label="Enter First Name" type="text" required placeholder="Please enter your First Name" :error="errors.firstName" />
        </div>
        <div style="margin-top: 30px">
          <custom-input :value="lastName" @update:value="lastName = $event" label="Enter Last Name" type="text" required placeholder="Enter Last Name" :error="errors.lastName" />
        </div>
        <div style="margin-top: 30px">
          <custom-input :value="emailId" readonly @update:value="emailId = $event" label="Enter Email ID" type="email" required placeholder="Enter Email ID" :error="errors.emailId" />
        </div>
        <div style="margin-top: 30px">
          <custom-input :value="mobileNumber" @update:value="mobileNumber = $event" label="Enter Mobile Number" type="number" required placeholder="Enter Mobile Number" :error="errors.mobileNumber" />
        </div>

        <div class="buttonDiv">
          <custom-button type="submit" :disabled="loading">
            {{ loading ? 'Verifying...' : 'Next' }}
            <div v-if="loading" class="spinner-border text-white spinner-grow-sm" role="status"></div>
          </custom-button>
        </div>
      </form>
    </div>

    <p class="goBackLabel" @click="handleLogout" style="margin-top: 10px !important">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M20 12H4M4 12L10 6M4 12L10 18" stroke="#32393E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      Back To Login
    </p>
  </div>
  <Footer />
</template>

<script>
import { useAuthStore } from '@/stores/authStore'
import CustomInput from '../../components/CustomInput.vue'
import CustomButton from '../../components/CustomButton.vue'
import { put } from '@/utils/api'
import { showToast } from '@/utils/toast'
import maxxifiedLogo from '@/assets/maxxified_logo.png'
import { useTenantStore } from '@/stores/tenantStore'
import whiteLogo from '@/assets/whiteLogo.png'
import Footer from '../../components/Footer.vue'
export default {
  data() {
    return {
      whiteLogo,
      firstName: '',
      lastName: '',
      emailId: JSON.parse(localStorage.getItem('UserData'))?.email_id || '',
      userId: JSON.parse(localStorage.getItem('UserData'))?.id || '',
      tenantId: JSON.parse(localStorage.getItem('UserData'))?.tenant_id || '',
      mobileNumber: '',
      loading: false,
      errors: {
        firstName: '',
        lastName: '',
        emailId: '',
        mobileNumber: '',
      },
    }
  },
  components: {
    CustomInput,
    CustomButton,
    Footer,
  },
  computed: {
    tenant() {
      const store = useTenantStore()
      return store
    },
    auth() {
      return useAuthStore()
    },
    logoToDisplay() {
      const storedLogo = localStorage.getItem('logo')
      return storedLogo || maxxifiedLogo
    },
  },
  methods: {
    handleLogout() {
      localStorage.clear()
      this.$router.push('/login')
    },
    handleBackToDashboard() {
      const tenantName = localStorage.getItem('url_name')
      this.$router.push(`/${tenantName}/dashboard`)
    },
    async handleSubmit() {
      if (this.loading) return

      // Clear all errors
      this.errors = {
        firstName: '',
        lastName: '',
        emailId: '',
        mobileNumber: '',
      }

      // Validate fields
      if (!this.firstName?.trim()) {
        this.errors.firstName = 'First name is required'
        return
      }

      if (!this.lastName?.trim()) {
        this.errors.lastName = 'Last name is required'
        return
      }

      if (!this.emailId?.trim()) {
        this.errors.emailId = 'Email is required'
        return
      }

      if (!this.mobileNumber?.trim()) {
        this.errors.mobileNumber = 'Mobile number is required'
        return
      }

      // Validate mobile number format (10 digits)
      const mobileRegex = /^\d{10}$/
      if (!mobileRegex.test(this.mobileNumber)) {
        this.errors.mobileNumber = 'Mobile number must be 10 digits'
        return
      }

      try {
        this.loading = true
        const response = await put(`/v1/users/${this.userId}`, {
          first_name: this.firstName.trim(),
          last_name: this.lastName.trim(),
          email_id: this.emailId.trim(),
          phone_number: this.mobileNumber.trim(),
          status: 'Active',
          is_active: true,
          tenant_id: this.tenantId,
        })

        if (response?.data?.code === 200) {
          // Update localStorage with new user data
          const updatedUserData = {
            ...JSON.parse(localStorage.getItem('UserData')),
            first_name: this.firstName.trim(),
            last_name: this.lastName.trim(),
            phone_number: this.mobileNumber.trim(),
          }
          localStorage.setItem('UserData', JSON.stringify(updatedUserData))

          showToast({
            title: 'Success',
            message: 'User details updated successfully',
            type: 'success',
          })
          this.handleBackToDashboard()
        } else {
          showToast({
            title: 'Error',
            message: response?.data?.message || 'Failed to update user details',
            type: 'error',
          })
        }
      } catch (error) {
        showToast({
          title: 'Error',
          message: error?.response?.data?.message || 'Failed to update user details',
          type: 'error',
        })
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    // Initialize tenant store with user's tenant ID
    const userData = JSON.parse(localStorage.getItem('UserData'))
    if (userData?.tenant_id) {
      const tenantStore = useTenantStore()
      tenantStore.fetchTenantConfigs(userData.tenant_id)
    }
  },
}
</script>

<style scoped>
@import '@/styles/login.css';
</style>
